(() => {
  const root = document.querySelector('[data-lumi-info-center]');
  if (!root) return;
  const shell = root.querySelector('.lumi-info-center__shell');
  const tabs = [...root.querySelectorAll('[data-lumi-info-tab]')];
  const panels = [...root.querySelectorAll('[data-lumi-info-panel]')];
  const closers = [...root.querySelectorAll('[data-lumi-info-close]')];
  let previousFocus = null;

  const validId = (id) => panels.some((panel) => panel.dataset.lumiInfoPanel === id);

  const showPanel = (id) => {
    if (!validId(id)) id = 'about-us';
    panels.forEach((panel) => { panel.hidden = panel.dataset.lumiInfoPanel !== id; });
    tabs.forEach((tab) => tab.setAttribute('aria-selected', tab.dataset.lumiInfoTab === id ? 'true' : 'false'));
    const title = root.querySelector('#LumiInfoTitle');
    const active = tabs.find((tab) => tab.dataset.lumiInfoTab === id);
    if (title && active) title.textContent = active.textContent.trim();
    const content = root.querySelector('[data-lumi-info-content]');
    if (content) content.scrollTop = 0;
  };

  const open = (id, updateHash = true) => {
    previousFocus = document.activeElement;
    showPanel(id);
    root.hidden = false;
    document.documentElement.classList.add('lumi-info-center-open');
    document.body.classList.add('lumi-info-center-open');
    if (updateHash) history.pushState({ lumiInfo: id }, '', `#lumi-${id}`);
    requestAnimationFrame(() => shell.focus());
  };

  const close = (updateHash = true) => {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('lumi-info-center-open');
    document.body.classList.remove('lumi-info-center-open');
    if (updateHash && location.hash.startsWith('#lumi-')) {
      history.pushState({}, '', `${location.pathname}${location.search}`);
    }
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lumi-info-open]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger.dataset.lumiInfoOpen || 'about-us');
  });

  tabs.forEach((tab) => tab.addEventListener('click', () => {
    const id = tab.dataset.lumiInfoTab;
    showPanel(id);
    history.replaceState({ lumiInfo: id }, '', `#lumi-${id}`);
  }));
  closers.forEach((button) => button.addEventListener('click', () => close()));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !root.hidden) close(); });
  window.addEventListener('popstate', () => {
    const id = location.hash.startsWith('#lumi-') ? location.hash.replace('#lumi-', '') : '';
    if (id && validId(id)) open(id, false); else close(false);
  });

  const initial = location.hash.startsWith('#lumi-') ? location.hash.replace('#lumi-', '') : '';
  if (initial && validId(initial)) open(initial, false);
})();
